import React, { useState } from 'react';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, SupervisedUserCircle } from '@mui/icons-material';
import { DialogConfirmAction } from '../../../components/dialogs/DialogConfirmAction';
import { useDispatch } from 'react-redux';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useNotification } from '../../../hooks/useNotification';
import { impersonateUser, parseImpersonateSession } from '../../../services/auth.service';
import { buildImpersonateStorageKey } from '../ImpersonateScreen';

export const LoadActions = ({ data, handleEdit, handleDelete, t }) => {
    const [{ userSession }] = useDataAuth();
    const dispatch = useDispatch();
    const [sendNotification] = useNotification();
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [idUser, setIdUser] = useState(false);
    const [impersonating, setImpersonating] = useState(false);

    const DeleteUser = () => {
        setOpenConfirmation(false);
        dispatch(handleDelete(userSession.token, idUser));
    }

    const handleImpersonate = async () => {
        if (!data?.user_name || impersonating) return;

        setImpersonating(true);
        try {
            const response = await impersonateUser(data.user_name, userSession.token);
            // const response = {
            //     data: {
            //         "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImpvcmdlLmFjZXZlZG9Aemlib3JkZXNhcnJvbGxhZG9yZXMuY29tIiwiaWRVc2VyIjoiMjIiLCJleHAiOjE3ODU5NDMyODQsImlhdCI6MTc4NTg1Njg4NH0.zr6yVuNjTxy2LoBIgYsMsL1ExmMSUfsyMbt6evCydnU",
            //         "name": "jorge",
            //         "last_name": "acevedo Zibor",
            //         "updated": "2026-08-04 15:21:24",
            //         "pending_action": "",
            //         "additional_field": ""
            //     }
            // }
            const session = parseImpersonateSession(response?.data);

            if (!session?.token) {
                sendNotification({
                    msg: t('user.impersonateError'),
                    variant: 'error'
                });
                return;
            }

            const userData = {
                session: {
                    ...session,
                    isImpersonating: true
                },
                username: data.user_name,
                accessDate: new Date().getTime()
            };

            const key = buildImpersonateStorageKey();
            localStorage.setItem(key, JSON.stringify(userData));
            setTimeout(() => localStorage.removeItem(key), 60000);

            const opened = window.open(`/impersonate?key=${encodeURIComponent(key)}`, '_blank');
            if (!opened) {
                localStorage.removeItem(key);
                sendNotification({
                    msg: t('user.impersonatePopupBlocked'),
                    variant: 'warning'
                });
                return;
            }

            sendNotification({
                msg: t('user.impersonateSuccess', {
                    name: `${data.name || ''} ${data.last_name || ''}`.trim() || data.user_name
                }),
                variant: 'success'
            });
        } catch (err) {
            console.error('Error al suplantar usuario', err);
            sendNotification({
                msg: t('user.impersonateError'),
                variant: 'error'
            });
        } finally {
            setImpersonating(false);
        }
    };

    return (
        <>
            <Box>
                <Tooltip title={t('edit')}>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleEdit(data, false)}
                        sx={{
                            color: 'gray',
                        }}
                    >
                        <Edit />
                    </IconButton>
                </Tooltip>

                <Tooltip title={t('user.impersonate')}>
                    <span>
                        <IconButton
                            aria-label="impersonate"
                            onClick={handleImpersonate}
                            disabled={impersonating || !data?.user_name}
                            sx={{
                                color: 'primary.main',
                            }}
                        >
                            {impersonating
                                ? <CircularProgress size={20} />
                                : <SupervisedUserCircle />
                            }
                        </IconButton>
                    </span>
                </Tooltip>

                <Tooltip title={t('delete')}>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            setOpenConfirmation(true);
                            setIdUser(data.id_user);
                        }}
                        sx={{
                            color: 'red',
                        }}
                    >
                        <Delete />
                    </IconButton>
                </Tooltip>
            </Box>

            <DialogConfirmAction
                openDialogConfirm={openConfirmation}
                setOpenDialogConfirm={() => setOpenConfirmation(false)}
                titleDialog={'Eliminar usuario'}
                textConfirmAction={"¿Esta seguro que desea eliminar el registro?"}
                textButtonConfirm={"Aceptar"}
                textButtonCancel={"Cancelar"}
                handleConfirmAction={DeleteUser}
            />
        </>
    )
}
